import { render, staticRenderFns } from "./VPayments.vue?vue&type=template&id=8eef1468&"
import script from "./VPayments.vue?vue&type=script&lang=js&"
export * from "./VPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports